import styled from 'styled-components';
import { tableBorder } from '../../constants/style';

const TableBody = styled.tbody`
  background-color: #FFFFFF;
  border-left: ${tableBorder};
`;

export default TableBody;
